module.exports = __webpack_public_path__ + "img/symbol_11.21542a38.png";